import { FC } from 'react';
import { MobileMenuItem, MobileMenuItemProps } from './HamburgerMenuLink';
import { shouldHideWithLocaleOverride } from '@/utils/localeOverride';
import useUserCourses from '@/lib/api/playbackService/hooks/useUserCourses';

export const MaybeRenderCoursePacksLink: FC<MobileMenuItemProps> = ({
  link,
  indented,
  onMenuItemTap,
}) => {
  const shouldFetch = !shouldHideWithLocaleOverride(link.fields.localeOverride);
  const { data, loading } = useUserCourses(shouldFetch);

  if (loading) return null;

  const userHasCourseAccess = data?.courses?.length;

  if (!userHasCourseAccess) return null;

  return (
    <MobileMenuItem
      link={link}
      onMenuItemTap={onMenuItemTap}
      indented={!!indented}
    />
  );
};
